//import { Workbox } from "workbox-window";
//import OneSignal from 'OneSignal';
import OneSignal from 'react-onesignal';

function unregisterAllServiceWorkers() {
  if (!('serviceWorker' in navigator)) {
    return Promise.resolve();
  }

  return navigator.serviceWorker.getRegistrations().then((registrations) => {
    registrations.forEach((registration) => {
      registration.unregister();
    });
  });
}

export default function registerServiceWorker() {
  const isLocalhost = ['localhost', '127.0.0.1', '[::1]'].includes(
    window.location.hostname
  );

  // Never run service worker in local development to avoid stale hashed bundles.
  if (process.env.NODE_ENV !== 'production' || isLocalhost) {
    unregisterAllServiceWorkers();
    return;
  }

  const oneSignalAppId = Env.ONE_SIGNAL_APP_ID;
  if ("serviceWorker" in navigator) {
    unregisterAllServiceWorkers().then(function() {
      // Register the new service worker
      navigator.serviceWorker.register('/serviceworker.js')
        .then(function(registration) {
          // Initialize OneSignal
          OneSignal.push(function() {
            OneSignal.SERVICE_WORKER_PATH = '/serviceworker.js';
            OneSignal.SERVICE_WORKER_PARAM = { scope: '/' };
            OneSignal.SERVICE_WORKER_UPDATER_PATH = '/serviceworker.js';
            OneSignal.init({
              appId: oneSignalAppId,
              serviceWorkerPath: '/serviceworker.js',
              allowLocalhostAsSecureOrigin: true,
              notifyButton: {
                enable: true,
              },
            });

            OneSignal.on('subscriptionChange', function(isSubscribed) {
              if (isSubscribed) {
                OneSignal.setExternalUserId(externalUserId);
              }
            });

            OneSignal.showSlidedownPrompt();
          });
        })
        .catch(function(err) {
          console.log('ServiceWorker registration failed: ', err);
        });
    });
  }
}
